Object.defineProperty(exports, '__esModule', {
  value: true
});
var addSpace = function addSpace(postcode, location) {
  return [postcode.slice(0, location), " ", postcode.slice(location)].join("");
};
var formatPostcode = function formatPostcode(postcode) {
  if (typeof postcode != "string") return false;
  var spaces = postcode.indexOf(" ");
  if (spaces === 2 || spaces === 3 || spaces === 4) {
    return postcode;
  }
  if (postcode.length === 5) {
    return addSpace(postcode, 2);
  }
  if (postcode.length === 6) {
    return addSpace(postcode, 3);
  }
  if (postcode.length === 7) {
    return addSpace(postcode, 4);
  }
  return postcode;
};
exports.formatPostcode = formatPostcode;